// Friendly labels + tailwind classes for enum values coming from the API.

export const ROLE_LABEL = {
    SUPER_ADMIN: "Super Admin",
    FRANCHISE_OWNER: "Franchise Owner",
    DISTRICT_MANAGER: "District Manager",
    SUPERVISOR: "Supervisor",
    STAFF: "Staff",
    ACCOUNTS: "Accounts",
    SHOP_OWNER: "Shop Owner",
};

export const ROLE_CLASSES = {
    SUPER_ADMIN: "bg-neutral-900 text-white",
    FRANCHISE_OWNER: "bg-amber-100 text-amber-900",
    DISTRICT_MANAGER: "bg-orange-100 text-orange-900",
    SUPERVISOR: "bg-indigo-100 text-indigo-900",
    STAFF: "bg-sky-100 text-sky-900",
    ACCOUNTS: "bg-emerald-100 text-emerald-900",
    SHOP_OWNER: "bg-fuchsia-100 text-fuchsia-900",
};

export const USER_STATUS_LABEL = {
    ACTIVE: "Active",
    PENDING_APPROVAL: "Awaiting verification",
    REJECTED: "Rejected",
    SUSPENDED: "Suspended",
};

export const USER_STATUS_CLASSES = {
    ACTIVE: "bg-emerald-100 text-emerald-900",
    PENDING_APPROVAL: "bg-amber-100 text-amber-900",
    REJECTED: "bg-rose-100 text-rose-900",
    SUSPENDED: "bg-neutral-200 text-neutral-800",
};

export const POST_STATUS_LABEL = {
    DRAFT: "Draft",
    PUBLISHED: "Live",
    EXPIRED: "Expired",
    ARCHIVED: "Archived",
};

export const POST_STATUS_CLASSES = {
    DRAFT: "bg-amber-100 text-amber-900",
    PUBLISHED: "bg-emerald-100 text-emerald-900",
    EXPIRED: "bg-neutral-200 text-neutral-800",
    ARCHIVED: "bg-rose-100 text-rose-900",
};

export const POST_TYPE_LABEL = {
    OFFER: "Offer",
    MOVIE: "Movie",
    EVENT: "Event",
    JOB_FAIR: "Job Fair",
    EXHIBITION: "Exhibition",
};

export const POST_TYPES = Object.keys(POST_TYPE_LABEL);
